import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.application.title',
    defaultMessage: 'APPLICATIONS',
  },
  back: {
    id: 'reports.application.back',
    defaultMessage: 'Back',
  },
  school: {
    id: 'reports.application.school',
    defaultMessage: 'School',
  },
  class: {
    id: 'reports.application.class',
    defaultMessage: 'Class',
  },
  chain: {
    id: 'reports.application.chain',
    defaultMessage: 'Chain',
  },
  deliver: {
    id: 'reports.application.deliver',
    defaultMessage: 'Application date',
  },
  edit: {
    id: 'reports.application.edit',
    defaultMessage: 'Edit',
  },
  studentsSingle: {
    id: 'reports.application.studentsSingle',
    defaultMessage: 'Registered student',
  },
  studentsPlural: {
    id: 'reports.application.studentsPlural',
    defaultMessage: 'Registered students',
  },
  replyCardsAttachedPlural: {
    id: 'reports.application.replyCardsAttachedPlural',
    defaultMessage: 'reply cards attached',
  },
  replyCardsAttachedSingle: {
    id: 'reports.application.replyCardsAttachedSingle',
    defaultMessage: 'reply card attached',
  },
  questionAprovation: {
    id: 'reports.application.questionAprovation',
    defaultMessage: 'Approval of issues',
  },
  questionNoDate: {
    id: 'reports.application.questionNoDate',
    defaultMessage: 'No date',
  },
  to: {
    id: 'reports.application.to',
    defaultMessage: 'to',
  },
  seeReports: {
    id: 'reports.application.seeReports',
    defaultMessage: 'View Reports',
  },
  application: {
    id: 'reports.application.application',
    defaultMessage: 'Application',
  },
  status: {
    id: 'reports.application.status',
    defaultMessage: 'Status',
  },
  finish: {
    id: 'reports.application.finish',
    defaultMessage: 'Finish',
  },
  requiredField: {
    id: 'reports.application.requiredField',
    defaultMessage: 'Please fill in this field.',
  },
  evaluationCriteria: {
    id: 'reports.application.evaluationCriteria',
    defaultMessage: 'Evaluation Criteria',
  },
  updateEvaluationCriteria: {
    id: 'reports.application.updateEvaluationCriteria',
    defaultMessage: 'Update Criterion',
  },
  updatedSuccessfully: {
    id: 'reports.application.updatedSuccessfully',
    defaultMessage: 'Successfully updated',
  },
  updateWithError: {
    id: 'reports.application.updateWithError',
    defaultMessage: 'Error trying to update',
  },
  close: {
    id: 'reports.application.close',
    defaultMessage: 'Close',
  },
  onlyPositiveValues: {
    id: 'reports.application.onlyPositiveValues',
    defaultMessage: 'Only positive values.',
  },
  noCardsFound: {
    id: 'reports.application.noCardsFound',
    defaultMessage: 'No cards found for the selected year',
  },
});
